const PinInput = {
  baseStyle: {
    color: "ms-red.900",
    borderRadius: "ms-8",
    textStyle: "subtitle2",
  },
  sizes: {
    desktop: {
      boxSize: "3.5rem",
    },
    mobile: {
      boxSize: "2.5rem",
    },
  },
};

export default PinInput;
